module.exports = __webpack_public_path__ + "static/media/Mauricio Tellez-Sanchez.87128617.png";